import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { FlightShopSummaryPanel } from "./component";
import { IStoreState } from "../../../../../../reducers/types";
import {
  getAirportMap,
  getSelectedTrip,
  hasTravelFusionInSelectedTripDetailsSelector,
  isOutgoingMultiTicketSelector,
  isReturnMultiTicketSelector,
  tripDetailsSelector,
} from "../../../../../flight-shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = getSelectedTrip(state);

  const tripId = selectedTrip?.tripId || "";
  const airports = getAirportMap(state);
  const tripDetails = tripDetailsSelector(state, tripId);
  const fareDetails = tripDetails
    ? tripDetails.fareDetails.find(
        (f) =>
          f.id === (selectedTrip?.returnFareId || selectedTrip?.outgoingFareId)
      )
    : undefined;

  return {
    tripDetails: tripDetailsSelector(state, tripId),
    fareDetails,
    airports,
    isOutgoingMultiTicket: isOutgoingMultiTicketSelector(state),
    isReturnMultiTicket: isReturnMultiTicketSelector(state),
    hasTravelFusionFareBrand:
      hasTravelFusionInSelectedTripDetailsSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightShopSummaryPanelConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightShopSummaryPanel = connector(
  withRouter(FlightShopSummaryPanel)
);
